<div class="tool-tip box is-elevation-4"><ng-content></ng-content></div>
